// extracted by mini-css-extract-plugin
export default {"popUpWrap":"styles_popUpWrap__qxoSq","popUp":"styles_popUp__dZh8k","popUpOpen":"styles_popUpOpen__vZ1G1","schoolsModal":"styles_schoolsModal__uT09g"};